export const GAMERS_DAYS_CAMPAIGNS = 'gamers-day';
